/**
 * Feature flags for controlling feature visibility.
 * Flip a flag to `true` to re-enable a feature once validated.
 */
export const FEATURE_FLAGS = {
	/** Smart Oblique capture mode — disabled pending field-testing */
	SMART_OBLIQUE_ENABLED: false,

	/** Height measurement at DSP waypoints — disabled pending validation */
	HEIGHT_MEASUREMENT_ENABLED: false,

	/** Maximum allowed flight height in meters (no regulatory cap enforced in UI) */
	MAX_FLIGHT_HEIGHT: 500,

	/** EU/Norway altitude threshold requiring special authorization (meters AGL) */
	AUTHORIZATION_HEIGHT_THRESHOLD: 120,
};
